import { render, staticRenderFns } from "./AnaliticalChat.vue?vue&type=template&id=51d2a958"
import script from "./AnaliticalChat.vue?vue&type=script&lang=js"
export * from "./AnaliticalChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports